import { apiCall } from './apiCall';



export default function reportApi() {
  return {
    getReportsData: (data,token) => apiCall('/getReports',data, token),
    getProductKeyLis: (data,token) => apiCall('/productKeysList',data, token),
    exportSoldQuantityReport: (data,token) => apiCall('/productQuantitySoldbyMerchentReport',data, token),
    exportMerchantMarginReport: (data,token) => apiCall('/merchantMarginReport',data, token),
    export: (data,token) => apiCall('/exportReports',data, token),
    getMerchantSummary: (data,token) => apiCall('/getMerchentSummary',data, token),
    
    
     
  };
}




